import React, { useEffect, useState } from 'react';
import grievanceRedressalImage from '../../../assets/images/grievance-redressal-image.png';
import Visit_us_verticle_line from '../../../assets/images/grievance-redressal-ver-line.png';
import ContactIcon from '../../../assets/images/contact-icon.png';
import EmailIdIcon from '../../../assets/images/email-Id-icon.png';
import ProfileIcon from '../../../assets/images/profile-icon.png';
import DGVLogo from '../../../assets/images/DGV.png';
import KarnatakaBankLogo from '../../../assets/images/KarnatakaBankLogo.png';
import FederalBankLogo from '../../../assets/images/federal_bank.png';
import grievanceRedressalTopLine from '../../../assets/images/grievance-redressal-top-line.svg';
import grievanceRedressalBottomLine from '../../../assets/images/grievance-redressal-bottom-line.svg';
import grievanceMobMiddleLine from '../../../assets/images/grievance-mob-middle-line.svg';
import grievanceMobBottomLine from '../../../assets/images/grievance-mon-bottom-line.svg';

import './GrievanceRedressal.css';

const GrievanceRedressal = () => {
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    if (window.innerWidth >= 1112) {
      setMobileView(true);
    }
  }, [mobileView]);
  return (
    <div className="grievance-redressal-main-container page-content">
      <div className="grievance-redressal-info-section">
        <div className="grievance-redressal-title-box">
          <div className="grievance-redressal-heading">Grievance Redressal</div>
          <div className="grievance-redressal-sub-heading">
            If you are not satisfied with our services &<br></br> would like to submit a complaint, please<br></br>{' '}
            follow the procedure.
          </div>
        </div>
        <div className="grievance-redressal-image-box">
          <img src={grievanceRedressalImage} alt="banner-img" />
        </div>
      </div>

      {/* contact and mail section */}
      {mobileView ? (
        <>
          <div className="grievance-redressal-top-line">
            <img src={grievanceRedressalTopLine} alt="top line" />
            <p className="grievance-redressal-social-section-head">GRO Details</p>
          </div>

          <div className="grievance-redressal-social-section">
            <div className="grievance-redressal-contact-box">
              <div className="grievance-redressal-social-logo-container">
                <img className="grievance-redressal-social-logo" src={DGVLogo} alt="Dgv Logo" />
              </div>
              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={ProfileIcon} alt="profile" />
                </div>
                <div className="grievance-redressal-title">Mr. Suryanarayana Reddy</div>
              </div>

              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={EmailIdIcon} alt="Email" />
                </div>
                <div className="grievance-redressal-title">
                  <a href="mailto:pno@dgv.in">pno@dgv.in</a>
                </div>
              </div>
              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={ContactIcon} alt="contact" />
                </div>
                <div className="grievance-redressal-title">+91 9646348348</div>
              </div>
            </div>
            <div className="grievance-redressal-cin-line">
              <img src={Visit_us_verticle_line} alt="vertical-line" />
            </div>
            <div className="grievance-redressal-contact-box">
              <div className="grievance-redressal-social-logo-container">
                <img className="grievance-redressal-social-logo" src={KarnatakaBankLogo} alt="Karnatak Bank Logo" />
              </div>
              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={ProfileIcon} alt="profile" />
                </div>
                <div className="grievance-redressal-title">Mr. Syed Sabir Hasan S</div>
              </div>

              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={EmailIdIcon} alt="Email" />
                </div>
                <div className="grievance-redressal-title">
                  <a href="mailto:no.digitallending@ktkbank.com">no.digitallending@ktkbank.com</a>
                </div>
              </div>
              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={ContactIcon} alt="contact" />
                </div>
                <div className="grievance-redressal-title">080-28062151</div>
              </div>
            </div>
            <div className="grievance-redressal-cin-line">
              <img src={Visit_us_verticle_line} alt="vertical-line" />
            </div>

            {/* Federal bank */}
            <div className="grievance-redressal-contact-box">
              <div className="grievance-redressal-social-logo-container">
                <img className="grievance-redressal-social-logo" src={FederalBankLogo} alt="Federal Bank Logo" />
              </div>
              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={ProfileIcon} alt="profile" />
                </div>
                <div className="grievance-redressal-title">Mr. Nikhil A</div>
              </div>

              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={EmailIdIcon} alt="Email" />
                </div>
                <div className="grievance-redressal-title">
                  <a href="mailto:dlcare@federalbank.co.in">dlcare@federalbank.co.in</a>
                </div>
              </div>
              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={ContactIcon} alt="contact" />
                </div>
                <div className="grievance-redressal-title">0484-6147400</div>
              </div>
            </div>
          </div>
          <div className="grievance-redressal-bottom-line">
            <img src={grievanceRedressalBottomLine} alt="bottom line" />
          </div>
        </>
      ) : (
        <div className="grievance-mob-container">
          <div className="grievance-mob-contact">
            <div className="grievance-redressal-contact-box">
              <div className="grievance-redressal-social-logo-container">
                <img className="grievance-redressal-social-logo" src={DGVLogo} alt="Dgv Logo" />
              </div>
              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={ProfileIcon} alt="profile" />
                </div>
                <div className="grievance-redressal-title">Mr. Suryanarayana Reddy</div>
              </div>

              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={EmailIdIcon} alt="Email" />
                </div>
                <div className="grievance-redressal-title">
                  <a href="mailto:pno@dgv.in">pno@dgv.in</a>
                </div>
              </div>
              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={ContactIcon} alt="contact" />
                </div>
                <div className="grievance-redressal-title">+91 9646348348</div>
              </div>
            </div>
          </div>
          <div className="grievance-mon-middle-line">
            <img src={grievanceMobMiddleLine} alt="middle-line"></img>
          </div>
          <div className="grievance-mob-contact">
            <div className="grievance-redressal-contact-box">
              <div className="grievance-redressal-social-logo-container">
                <img className="grievance-redressal-social-logo" src={KarnatakaBankLogo} alt="Karnataka Bank Logo" />
              </div>
              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={ProfileIcon} alt="profile" />
                </div>
                <div className="grievance-redressal-title">Mr. Syed Sabir Hasan S</div>
              </div>

              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={EmailIdIcon} alt="Email" />
                </div>
                <div className="grievance-redressal-title">
                  <a href="mailto:no.digitallending@ktkbank.com">no.digitallending@ktkbank.com</a>
                </div>
              </div>
              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={ContactIcon} alt="contact" />
                </div>
                <div className="grievance-redressal-title">080-28062151</div>
              </div>
            </div>
          </div>
          <div className="grievance-mon-bottom-line">
            <img src={grievanceMobBottomLine} alt="bottom-line"></img>
          </div>
          <div className="grievance-mob-email">
            <div className="grievance-redressal-contact-box">
              <div className="grievance-redressal-social-logo-container">
                <img className="grievance-redressal-social-logo" src={FederalBankLogo} alt="Federal Bank Logo" />
              </div>
              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={ProfileIcon} alt="profile" />
                </div>
                <div className="grievance-redressal-title">Mr. Nikhil A</div>
              </div>

              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={EmailIdIcon} alt="Email" />
                </div>
                <div className="grievance-redressal-title">
                  <a href="mailto:dlcare@federalbank.co.in">dlcare@federalbank.co.in</a>
                </div>
              </div>
              <div className="grievance-redressal-title-img">
                <div className="grievance-redressal-img">
                  <img src={ContactIcon} alt="contact" />
                </div>
                <div className="grievance-redressal-title">0484-6147400</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GrievanceRedressal;
